import { z } from 'zod';

import { VALIDATION_MESSAGES } from '@/constants/constant';

export const addAdminSchema = z.object({
  name: z
    .string()
    .trim()
    .nonempty(VALIDATION_MESSAGES.adminName.required)
    .min(2, VALIDATION_MESSAGES.adminName.min)
    .max(100, VALIDATION_MESSAGES.adminName.max),

  email: z
    .string()
    .trim()
    .nonempty(VALIDATION_MESSAGES.adminEmail.required)
    .min(5, VALIDATION_MESSAGES.adminEmail.min)
    .max(100, VALIDATION_MESSAGES.adminEmail.max)
    .refine(
      (val) =>
        /^[a-zA-Z0-9](?!.*[-_.]{2})[a-zA-Z0-9._%+-]*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,10}$/.test(
          val
        ),
      {
        message: VALIDATION_MESSAGES.adminEmail.invalid,
      }
    ),
  role: z.string().min(1, VALIDATION_MESSAGES.adminRole.required),
});

export type TAddAdminFormValues = z.infer<typeof addAdminSchema>;
